import React from 'react';
import { connect } from 'react-redux';

import i18n from 'I18n';

import ReactHookFormMultipleSelector from 'components/reactHookFormComponents/ReactHookFormMultipleSelector';
import { SectionTopTitle } from 'components/base/CommonComponent';
import { createAction } from 'utils';
import { LanguageConfig } from 'config/CustomEnums';

function TaskSection({
  language,
  focusChange = () => { }
}) {
  return (
    <>
      {language !== LanguageConfig.english ?
        <></> :
        <>
          <SectionTopTitle title={i18n.t('task', { local: language })} />
          <ReactHookFormMultipleSelector
            language={language}
            focusChange={focusChange}
            loadSourceDataAction={(dispatch) => {
              dispatch(createAction('earningRuleList/getAllList')({
                isAll: true,
                linkedCampaignType: 'STAMP_CAMPAIGN',
              }));
            }}
            getSourceDataFromState={(state) => state.earningRuleList.notPagedAllList}
            valueFieldName={"linkedEarningRules"}
            title={"Link to earning rules"}
            namespace={"earningRuleList"}
            custom={{
              customItem: (item) => `[ID: ${item.pk}] ${item.name}`,
            }}
            sortable={false}
            focusKey="tasks"
          />
        </>
      }

    </>
  );
}

const mapPropsToState = (state) => ({
  languages: state.language.allList,
});
export default connect(mapPropsToState)(TaskSection);
